<!-- Searchbox -->
<section class="searchbox-wrapper">
  <input type="search" placeholder="Reg.nr/bokningsnr." [formControl]="searchInput" #searchBox
    (input)="search(searchInput.value || undefined)" data-test="search-in-list" spellcheck="false" autocomplete="off" />
  </section>

  <div class="search-result-wrapper">
    <!-- Driver mode: compact driver list rows -->
    @if (isDriverMode && searchResult && !termNotFound) {
      <app-driver-bookings-list [class.in-search]="isDriverMode"
        [bookings]="searchResult" [topic]="currentDirection">
      </app-driver-bookings-list>
    }

    <!-- Normal mode: preserve old table behavior -->
    @if (!isDriverMode && searchResult && !termNotFound) {
      <div class="report-table-scroll" tabindex="0"
        role="region" aria-label="Sökresultat i bokningstabellen på startsidan">
        <app-bookings-table [bookings]="searchResult" [topic]="currentDirection" [coloredSearchResult]="true">
        </app-bookings-table>
      </div>
    }

    <!-- Booking not found -->
    @if (termNotFound && !searchResult) {
      <div class="empty-content empty-content-colored">
        <p>Kunde inte hitta en bokning med "{{ termNotFound }}"</p>
      </div>
    }

    <!-- No search result -->
    @if (!termNotFound && !searchResult) {
      <div class="empty-content empty-content-colored">
        <p>Sök på registrerings- eller bokningsnummer för att filtrera i {{currentDirection === 'arrival' ? 'hämtlistan': 'bokningslistan'}}. </p>
      </div>
    }

    @if (showSpinner) {
      <div class="spinner-wrapper">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
